import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../login-service';

@Component({
  selector: 'app-emailverification',
  templateUrl: './emailverification.component.html',
  styleUrls: ['./emailverification.component.scss']
})
export class EmailverificationComponent implements OnInit {
  userID: any;

  constructor(private loginService:LoginService,private activateRoute: ActivatedRoute) { 
    this.userID = this.activateRoute.snapshot.params['userid'];
  }

  ngOnInit(): void {
   
    this.loginService.Updateverificationstatus(this.userID,'y').subscribe(data=>{
    })
  }

}
